import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
import CustomerInfoListComponent from "./views/CustomerInfoList";

const CustomerReportList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <CustomerInfoListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Customer Information",
          description: "customer info section"
        })}
      />
      <Routes>
        <Route path={""} element={<CustomerReportList />} />
      </Routes>
    </>
  );
};

export default Component;
